import apiClient from './apiClient';

// ===== Types =====
export interface CostQuote {
  id: number;
  quoteName: string;
  quoteNo: string;
  mode: number;
  config: string;   // JSON string
  result: string;   // JSON string
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCostQuoteRequest {
  quoteName: string;
  quoteNo?: string;
  mode: number;
  config: string;
  result?: string;
}

export interface UpdateCostQuoteRequest {
  quoteName?: string;
  quoteNo?: string;
  mode?: number;
  config?: string;
  result?: string;
}

export interface ListResponse {
  data: CostQuote[];
  total: number;
  page: number;
  pageSize: number;
}

// ===== API =====
const BASE = '/api/cost-quotes';

export const costcalcApi = {
  list: (page = 1, pageSize = 20) =>
    apiClient.get<ListResponse>(BASE, { params: { page, pageSize } }).then(r => r.data),

  get: (id: number) =>
    apiClient.get<CostQuote>(`${BASE}/${id}`).then(r => r.data),

  create: (data: CreateCostQuoteRequest) =>
    apiClient.post<CostQuote>(BASE, data).then(r => r.data),

  update: (id: number, data: UpdateCostQuoteRequest) =>
    apiClient.put<CostQuote>(`${BASE}/${id}`, data).then(r => r.data),

  delete: (id: number) =>
    apiClient.delete(`${BASE}/${id}`).then(r => r.data),
};
